export default __webpack_public_path__ + "static/media/flowers-3x.3afc3b6f.png";